import * as React from 'react';

import Card from '@mui/material/Card';

import { ICardInfo } from '../interfaces';

interface IProps {
  id?: string;
  cardInfo: ICardInfo;
}

function KPICard(props: IProps) {
  let {
    id,
    cardInfo: { title, name, description, color },
  } = props;

  return (
    <Card id={id} className="home-page__kpi-card">
      <h3 id={`home_page__kpi-${color}-card-title`} className={`kpi-card-title kpi-text-${color}`}>
        {title}
      </h3>
      <h4 id={`home_page__kpi-${color}-card-title`} className="kpi-card-name">
        {name}
      </h4>
      <div
        id={`home_page__kpi-${color}-card-title`}
        className={`kpi-card-line kpi-background-${color}`}
      />
      <p id={`home_page__kpi-${color}-card-title`} className="kpi-card-description">
        {description}
      </p>
    </Card>
  );
}

export { KPICard };
